/* Marks still-loading content images so component-image-skeleton.css can show a placeholder.
   Only theme images (width attr set; skips app overlays). Complete and eager (above-the-fold / LCP) images are left alone; no JS means no change. */
(function () {
  function done(img, ok) {
    img.classList.remove('is-skel');
    if (ok) img.classList.add('is-loaded');
  }
  function mark(img) {
    if (!img.hasAttribute('width') || img.complete || img.dataset.skel || img.classList.contains('secondary') ||
        img.loading === 'eager' || img.getAttribute('fetchpriority') === 'high') return;
    img.dataset.skel = '1';
    img.classList.add('is-skel');
    img.addEventListener('load', function () { done(img, true); }, { once: true });
    img.addEventListener('error', function () { done(img, false); }, { once: true });
  }
  function scan(root) {
    if (root.tagName === 'IMG') mark(root);
    else if (root.querySelectorAll) root.querySelectorAll('img').forEach(mark);
  }
  var main = document.getElementById('MainContent');
  if (!main) return;
  scan(main);
  new MutationObserver(function (list) {
    list.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); }); });
  }).observe(main, { childList: true, subtree: true });
})();
